<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 权限管理
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <span style = "margin-left:20px;font-size:15px;">权限名：</span>
          <el-input v-model="listQuery.description" placeholder="" style="width:200px;"></el-input>
          <span style = "margin-left:20px;font-size:15px;">状态：</span>
           <el-select v-model="listQuery.permission_status" filterable placeholder="请选择">
              <el-option
                v-for="item in statusOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
            </el-select>
            <span style = "margin-left:20px;font-size:15px;">是否显示：</span>
           <el-select v-model="listQuery.is_hidden" filterable placeholder="请选择">
              <el-option
                v-for="item in showCheckOptions"
                :key="item.index"
                :label="item.name"
                :value="item.id"
                >
              </el-option>
            </el-select>
            <span style = "margin-left:20px;font-size:15px;">方法：</span>
          <el-input v-model="listQuery.method" placeholder="" style="width:200px;"></el-input>

          <div style="float:right; margin:30px 30px 20px 0;">
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="handleFilter"
          >搜索</el-button>
          <el-button
            class="filter-item"
            type="success"
            @click="handleCreate"
          >添加</el-button>
          <el-button
            class="filter-item"
            type="warning"
            @click="resetAll"
          >重置</el-button>
          </div>
        </div>

        <el-table border v-loading="listLoading"  min-height="200"  max-height="1000" :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" />
          <el-table-column prop="description" label="权限名称" />
          <el-table-column prop="parent_description" label="父级名称" />
          <el-table-column prop="permission_status" label="状态" />
          <el-table-column prop="is_hidden" label="是否显示" />
          <el-table-column prop="method" label="方法" />
          <el-table-column label="操作" fixed="right" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button
                type="primary"
                style="margin-right: 10px;"
                size="mini"
                icon="el-icon-edit"
                @click="handleUpdate(scope.row)"
              >编辑</el-button>
              <el-button
                type="danger" 
                size="mini"
                @click="userDelete(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.limit"
          @pagination="permissionList"
        />

        <el-dialog title="删除"  center width="40%" :visible.sync="deleteShow">
            <p>确认删除此权限吗？</p>
            <div slot="footer" class="dialog-footer">
            <el-button @click="deleteShow = false">取 消</el-button>
            <el-button type="primary" @click="handleDelete">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="权限管理" width="35%" center :visible.sync="dialogFormVisible">
          <el-form :model="formData" style="margin-left:50px;">
                <el-form-item label="父级目录" :label-width="formLabelWidth">
                    <el-col :span="8">
                        <el-select v-model="formData.pid" filterable placeholder="请选择">
                            <el-option
                                v-for="item in parentDirectoryOptions"
                                :key="item.index"
                                :label="item.description"
                                :value="item.id"
                                >
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>

            <el-form-item label="权限名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.description"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="控制器名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.controller"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="方法名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="formData.method"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="是否显示" :label-width="formLabelWidth">
                    <el-col :span="8">
                        <el-select v-model="formData.is_hidden" filterable placeholder="请选择">
                            <el-option
                                v-for="item in showCheckOptions"
                                :key="item.index"
                                :label="item.name"
                                :value="item.id"
                                >
                            </el-option>
                        </el-select>
                    </el-col>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth">
                    <el-col :span="8">
                        <el-select v-model="formData.permission_status" filterable placeholder="请选择">
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.index"
                                :label="item.name"
                                :value="item.id"
                                >
                            </el-option>
                        </el-select>
                    </el-col>
            </el-form-item>
                
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleCreateUpdateStore">确 定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  permissionListApi,
  getParentPermissionApi,
  addPermissionApi,
  getSinglePermissionApi,
  putSinglePermissionApi,
  deletePermissionApi
} from "@/api/new_admin_permission.js";
import Pagination from "@/components/pagination/index";

export default {
  components: { Pagination },
  name :"newPermission",
  data() {
    return {
      // 列表
      listLoading: false,
      total: 0,
      tableData: [],
      listQuery: {
        description:"",
        permission_status:"",
        is_hidden:"",
        method:"",
        page: 1,
        limit: 10
      },
      editID:"",
      statusOptions:[
        {
          name:"正常",
          id:"1"
        },
        {
          name:"禁用",
          id:"0"
        },
      ],
      showCheckOptions:[
         {
          name:"否",
          id:"1"
        },
        {
          name:"是",
          id:"0"
        },
      ],
      parentDirectoryOptions:[],
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      formData: {
        id:"",
        pid: "",
        description:"",
        controller:"",
        method:"",
        is_hidden:"",
        permission_status:"",
      },
      judgeOperate:"",
      formLabelWidth: "120px",
      formInputWidth: "200px",
      // 删除
      deleteShow:false,
      delID:""
    };
  },
  created() {
    this.permissionList(this.listQuery);
  },
  methods: {
    permissionList() {
      this.listLoading = true;
      permissionListApi(this.listQuery)
        .then(response => {
          const data = response.data.data.data;
          let array = [];
          for(let item of data){
            if(item.is_hidden == 0){
              item.is_hidden = "是"
            }else if(item.is_hidden == 1){
              item.is_hidden = "否"
            }
            if(item.permission_status == 0){
              item.permission_status = "禁用"
            }else if(item.permission_status == 1){
              item.permission_status = "正常"
            }
            for(let m of this.parentDirectoryOptions){
               if (m.id == item.parent_description){
                 item.parent_description = m.description;
               }
            }
            array.push(item);
          }
          this.tableData = array;
          this.total = response.data.data.total;
          this.listLoading = false;
        })
        .catch(error => {
          this.listLoading = false;
        });
    },
    handleResetForm() {
      this.formData.pid = "";
      this.formData.description = "";
      this.formData.method = "";
      this.formData.controller = "",
      this.formData.is_hidden = "";
      this.formData.permission_status = "";
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.permissionList(this.listQuery);
    },
    handleCreate() {
      this.getParentPermission();
      this.handleResetForm();
      this.judgeOperate = 1;
      this.dialogFormVisible = true;
    },
    resetAll(){
        this.listQuery.description ="";
        this.listQuery.permission_status ="";
        this.listQuery.is_hidden ="";
        this.listQuery.method ="";
        this.listQuery.page = 1;
        this.listQuery.limit = 10;
        this.permissionList(this.listQuery);
    },
    getParentPermission(){
      getParentPermissionApi()
       .then(response =>{
         console.log("父级权限",response)
         this.parentDirectoryOptions = response.data.data;
       })
       .catch(error =>{
       })
    },
    handleCreateUpdateStore() {
      if(this.judgeOperate == 1){
        let data = {}
        data.pid = this.formData.pid;
        data.controller = this.formData.controller;
        data.method = this.formData.method;
        data.description = this.formData.description;
        data.is_hidden = this.formData.is_hidden;
        data.permission_status = this.formData.permission_status;
        addPermissionApi(data)
        .then(response => {
          if(response.data.code == 200){
            this.$message.success(response.data.message);
            this.dialogFormVisible = false;
            this.permissionList(this.listQuery);
          }
          else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {});
      }
      if(this.judgeOperate == 0){
        for(let item of this.parentDirectoryOptions)
         {
           if (item.description ==  this.formData.pid){
             this.formData.pid = item.id
           }
         }
         for(let item of this.showCheckOptions)
         {
           if (item.name ==  this.formData.is_hidden){
             this.formData.is_hidden = item.id
           }
         }
         for(let item of this.statusOptions)
         {
           if (item.name ==  this.formData.permission_status){
             this.formData.permission_status = item.id
           }
         }
        this.formData.id = this.editID;
        let editData ={}
        editData.id  = this.formData.id; 
        editData.pid  = this.formData.pid; 
        editData.description  = this.formData.description; 
        editData.controller  = this.formData.controller; 
        editData.method  = this.formData.method;
        editData.is_hidden  = this.formData.is_hidden; 
        editData.permission_status  = this.formData.permission_status; 
        putSinglePermissionApi(editData)
         .then(response=>{
          if(response.data.code == 200){
            this.dialogFormVisible = false;
            this.$message.success(response.data.message);
            this.permissionList(this.listQuery);
          }
          else {
            this.$message.error(response.data.message);
          }
         })
         .catch(error=>{})
      }
    },
    handleUpdate(row) {
      this.getParentPermission();
      this.judgeOperate = 0;
      this.editID = row.id;
      this.dialogFormVisible = true;
      let data = {
        id:""
      }
      data.id = row.id;
      getSinglePermissionApi(data)
       .then(response =>{
         const data = response.data.data;
         for(let item of this.parentDirectoryOptions)
         {
           if (item.id ==  data.pid){
             this.formData.pid = item.description
           }
         }
         this.formData.description = data.description ;
         this.formData.controller = data.controller ;
         this.formData.method = data.method ;
         for(let item of this.showCheckOptions)
         {
           if (item.id ==  data.is_hidden){
             this.formData.is_hidden = item.name
           }
         }
         for(let item of this.statusOptions)
         {
           if (item.id ==  data.permission_status){
             this.formData.permission_status = item.name
           }
         }
       })
       .catch(error=>{

       })
      this.formData.id = row.id;
      this.formData.description = row.description;
    },
    handleDownload() {
    },
    userDelete(item){
      this.deleteShow = true;
      this.delID = item.id;
    },
    handleDelete(row) {
      deletePermissionApi({id:this.delID})
        .then(response => {
          if(response.data.code == 200){
            this.$message.success(response.data.message.message);
            this.deleteShow = false;
            this.permissionList(this.listQuery);
          }
          else {
            this.$message.error(response.data.message.message);
            this.deleteShow = false;
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
</style>
